import React from 'react';
import Link from 'gatsby-plugin-transition-link/AniLink';
import { Grid, useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import styles from './style.module.scss';
import HeadlineSmall from '../HeadlineSmall';
import HeadlineLarge from '../HeadlineLarge';
import DefaultContainer from '../DefaultContainer';
import Image from '../Image';
import { wearePage } from '../../data';
import friendsLogo from '../../data/friends';

const FriendsSection = ({
  amount = friendsLogo.length,
  noPadding = false,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(
    theme.breakpoints.down('sm')
  );
  return (
    <DefaultContainer
      className={!noPadding && styles.container}
      direction="column"
      justify="flex-start"
    >
      <HeadlineSmall>
        {wearePage.friendsHeadlineSmall}
      </HeadlineSmall>
      <HeadlineLarge
        stroke={wearePage.friendsHeadlineLargeStroke}
        lineBreak
        className={styles.headlineLarge}
        medium
      >
        {wearePage.friendsHeadlineLarge}
      </HeadlineLarge>
      <Grid
        container
        justify="flex-start"
        spacing={isMobile ? 4 : 6}
      >
        {friendsLogo.slice(0, amount).map(friend => (
          <Grid
            key={friend.id}
            item
            xs={6}
            sm={4}
            md={3}
            className={styles.containerImage}
          >
            {friend.path ? (
              <Link fade to={`/cases/${friend.path}`}>
                <Image
                  source={friend.logo}
                  alt="company logo"
                  style={friend.style}
                  className={[
                    styles.img,
                    styles[friend.extraClass],
                  ].join(' ')}
                />
              </Link>
            ) : (
              <Image
                source={friend.logo}
                alt="company logo"
                style={friend.style}
                className={[
                  styles.img,
                  styles[friend.extraClass],
                ].join(' ')}
              />
            )}
          </Grid>
        ))}
      </Grid>
    </DefaultContainer>
  );
};

export default FriendsSection;
